const keysList = {
  bindings: {
    initLoading: '<',
    loading: '<',
    keys: '<',
    onGenerate: '&'
  },
  templateUrl: '/modules/key-manager/keys-list/keys-list.html',
  controller: 'KeysListController',
};

angular
  .module('key-manager.module')
  .component('keysList', keysList);
